import React, { useEffect, useRef } from "react";
import { isInViewport } from "./../../utils/viewport";

import "./CollapseItemStyle.css";
import Mais from "./../../assets/icons/Mais.svg";

const CollapseItem = ({ question, answers, selectedItem, item, onChange }) => {
  const questionRef = useRef();
  const lastOpenRef = useRef();

  const isOpen = selectedItem === item;

  const scroll = () => {
    setTimeout(() => questionRef.current.scrollIntoView(), 100);
  };
  const toggle = () => {
    lastOpenRef.current = !isOpen;
    if (isOpen) {
      onChange(-1);
      if (!isInViewport(questionRef.current)) {
        scroll();
      }
    } else {
      onChange(item);
    }
  };

  useEffect(() => {
    if (!isOpen && lastOpenRef.current) {
      if (!isInViewport(questionRef.current)) {
        scroll();
      }
    }
    lastOpenRef.current = isOpen;
  }, [isOpen]);

  return (
    <div className="Section_Collapse">
      <div className="item make-click" data-label={question} onClick={toggle}>
        <div className="Question">
          <h4 ref={questionRef} className="collapsible">
            {question}
          </h4>
          <img
            src={Mais}
            alt="Mais"
            className={`icon ${isOpen ? "rotate180" : "icon"}`}
          />
        </div>
        <div
          id="maxHeight"
          className={`content${isOpen ? " maxHeight100" : " maxHeight0"}`}
        >
          <div id={`container${item}`}>
            {(Array.isArray(answers) ? answers : []).map(
              (answer, index) =>
                (answer.type === "default" && (
                  <React.Fragment key={index}>
                    <p>{answer.text}</p>
                  </React.Fragment>
                )) ||
                (answer.type === "list" && (
                  <React.Fragment key={index}>
                    <ul>
                      <li>{answer.text}</li>
                    </ul>
                  </React.Fragment>
                )) ||
                (answer.type === "link" && (
                  <React.Fragment key={index}>
                    <a
                      href={answer.link}
                      target={answer.target}
                      rel="noopener noreferrer"
                    >
                      {answer.text}
                    </a>
                  </React.Fragment>
                )) ||
                (answer.type === "bold" && (
                  <React.Fragment key={index}>
                    <b>{answer.text}</b>
                  </React.Fragment>
                ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollapseItem;
